/** @jsx jsx */
import { jsx, Button } from 'theme-ui'
import { useEffect, useState } from 'react'
import { bool } from 'prop-types'
import { ScrollToTop } from '../../../icons'

const BackToTopButton = ({ useFixedPosition = false }) => {
  const [showButton, setShowButton] = useState(false)
  const [preventFooterOverlap, setPreventFooterOverlap] = useState(false)
  useEffect(() => {
    const onScroll = () => {
      // prevents footer over lap by the pop to top button when using fixed position
      // by compensating for the scrollHeight and scrollTop, the height of the footer and the client height.

      if (
        useFixedPosition &&
        document.documentElement.scrollHeight -
          document.documentElement.scrollTop <
          120 + document.documentElement.clientHeight
      ) {
        setPreventFooterOverlap(true)
      } else setPreventFooterOverlap(false)
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400
      ) {
        setShowButton(true)
      } else {
        setShowButton(false)
      }
    }
    window.addEventListener('scroll', onScroll)

    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const goToTop = () => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
  return (
    <div
      sx={{
        textAlign: 'right',
        position: useFixedPosition ? 'fixed' : 'sticky',
        bottom: preventFooterOverlap ? 150 : 4,
        // perecent is used to prevent pop to top button appearing to far to the left on smaller devices
        right: useFixedPosition ? '10%' : 'auto',
        display: showButton ? 'block' : 'none',
      }}
    >
      <Button
        sx={{
          padding: 0,
          border: 0,
          borderRadius: 0,
          height: '50px',
          ':focus': { outline: 'none' },
        }}
        onClick={goToTop}
      >
        <ScrollToTop />
      </Button>
    </div>
  )
}
BackToTopButton.propTypes = {
  useFixedPosition: bool,
}

export default BackToTopButton
